import { Participant, ParticipantDto } from "../models/Participant";
import { axiosInstance } from "./AxiosDefaults";
import {RcFile} from "antd/es/upload";

export const sendEmailNotification = (
    subject: string,
    content: string,
    recipients: any[],
    attachments: any[],
): Promise<any> => {
    const files = Array.from(attachments);
    const formData = new FormData();

    formData.append('subject', subject);
    formData.append('content', content);
    formData.append('recipients', JSON.stringify(recipients));

    for (const file of files) {
        formData.append('attachment', file.originFileObj, file.name);
    }

    return axiosInstance.post(
        "/email-notifications",
        formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        },
    );
};